export const FieldError = ({ message }: { message?: string }) =>
  message ? <p className="err-msg">{message}</p> : null;
